import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import messages from './messages';
import css from './index.scss';
import { hideToast } from './actions';

class Toast extends Component {
    constructor(props) {
        super(props);
        this.state = { isToastVisible: false, message: '' };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isToastVisible !== this.props.isToastVisible) {
            this.setState({ isToastVisible: nextProps.isToastVisible, message: nextProps.message });

            setTimeout(this.startTimer, 7000);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !(!nextProps.isToastVisible && !nextState.isToastVisible);
    }

    setToastColor = () => {
        const { messageType } = this.props;
        let color = '';
        switch (messageType) {
        case 'success': color = '#5cb85c';
            break;
        case 'warning': color = '#e07e02';
            break;
        default: color = '#c53902';
            break;
        }

        return color;
    }

    startTimer=() => {
        this.setState({ isToastVisible: false, message: '' });
        this.props.hideToast();
    };

    render() {
        const { intl } = this.props;
        return (this.state.isToastVisible && this.state.message) ?
            (
                <div className={css.toast} style={{ background: this.setToastColor() }}>
                    <div className={css.message}>{intl.formatMessage(messages[this.state.message])}</div>
                </div>
            ) :
            (
                <div />
            );
    }
}

const mapStateToProps = state => ({
    ...state,
    isToastVisible: state.toast.isToastVisible,
    message: state.toast.message,
    messageType: state.toast.messageType

});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        hideToast
    }, dispatch);
}

Toast.propTypes = {
    intl: intlShape.isRequired,
    message: PropTypes.string,
    isToastVisible: PropTypes.bool,
    hideToast: PropTypes.func,
    messageType: PropTypes.string
};

const StyledToast = (styleable(css)(Toast));

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(StyledToast));



// WEBPACK FOOTER //
// ./app/components/toast/index.js